import { componentModule } from "./utils/constants";
import { getFederatedObject } from "./utils/utility";
import { getKronosUrl } from "./utils/utility";
import { RemoteComponent } from "./components/RemoteComponent";
import { RemoteComponentProps } from "./components/RemoteComponent";
import { FederatedObject } from "./types/FederatedObject";

export { componentModule, getFederatedObject, getKronosUrl, RemoteComponent, RemoteComponentProps, FederatedObject };
